export interface IPagedResults<T> {
    first(): Promise<T[]>;
    next(): Promise<T[]>;
}

export class PagedResults<T> implements IPagedResults<T> {
    private _currentPageNumber: number;
    private _stopLoadingData: boolean;

    constructor(private _$http: angular.IHttpService,
        private _baseUrl: string,
        private _map: (value) => T,
        private _parameters: any,
        private _numberOfItemsPerPage: number) {
        this._numberOfItemsPerPage = this._numberOfItemsPerPage || 25;
        this._map = this._map || (v => v);
    }

    first(): Promise<T[]> {
        this._stopLoadingData = false;
        this._currentPageNumber = 1;
        return this.get();
    }

    next(): Promise<T[]> {
        this._currentPageNumber++;
        return this.get();
    }

    private get(): Promise<T[]> {
        if (this._stopLoadingData)
            return Promise.resolve([]);

        return new Promise<T[]>((resolve, reject) => {
            const url = this.buildUrl();
            this._$http.get(url).then((response: angular.IHttpPromiseCallbackArg<any[]>) => {
                const results = response.data.map(v => this._map(v));
                if (results.length < this._numberOfItemsPerPage)
                    this._stopLoadingData = true;
                resolve(results);
            });
        });
    }

    private buildUrl(): string {
        const queryString = this.buildQueryString();
        return `${this._baseUrl}${queryString}`;
    }

    private buildQueryString(): string {
        const queryParameters = this.buildQueryParameters();
        return queryParameters.length > 0
            ? `?${queryParameters.join('&')}`
            : '';
    }

    private buildQueryParameters(): string[] {
        const params = [];
        params.push(`currentPageNumber=${this._currentPageNumber}`);
        params.push(`numberOfItemsPerPage=${this._numberOfItemsPerPage}`);

        for (let param in this._parameters) {
            if (this._parameters.hasOwnProperty(param)
                && angular.isDefined(this._parameters[param])
                && this._parameters[param] !== ''
                && this._parameters[param] !== null)
                params.push(`${param}=${this._parameters[param]}`);
        }

        return params;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/paging/pagedResults.ts
 **/